// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/button/button.component.scss
// module id = 57
// module chunks = 0